import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PublicService } from './public.service';

@Injectable()
export class PublicHttpInterceptor implements HttpInterceptor {
  constructor(private publicService: PublicService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const publicCode = this.publicService.getCurrentPublicCode();

    if (publicCode) {
      // Add custom header with public code
      const clonedRequest = req.clone({
        setHeaders: {
          'X-Public-Code': publicCode
        }
      });
      return next.handle(clonedRequest);
    }

    return next.handle(req);
  }
}
